export default function sliceText(text, words) {
    if(text){
        return text?.length<=words?text:text.slice(0,words)+"..."
    }else{
        return ""
    }
} 